var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFireFeaturesFloodIncidentConfirmed = function SvgFireFeaturesFloodIncidentConfirmed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#21272C",
    strokeWidth: 2,
    d: "M11.293 3.121a1 1 0 0 1 1.414 0l8.172 8.172a1 1 0 0 1 0 1.414l-8.172 8.172a1 1 0 0 1-1.414 0L3.12 12.707a1 1 0 0 1 0-1.414z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    fillRule: "evenodd",
    d: "M18.61 12.39 12 19l-6.862-6.862c.417-.416.911-.638 1.433-.638.696 0 1.336.39 1.814 1.104.444.666 1.168.666 1.612 0 .479-.714 1.122-1.104 1.814-1.104.695 0 1.335.39 1.813 1.104.199.295.45.46.708.493.286 0 .583-.165.807-.493.479-.714 1.122-1.104 1.814-1.104a1.947 1.947 0 0 1 .097 0v.002c.585.031 1.127.34 1.56.887",
    clipRule: "evenodd"
  })));
};
export default SvgFireFeaturesFloodIncidentConfirmed;